export const CheckType = {
    ADMINISTRATION_FEE: 'ADMINISTRATION_FEE',
    AMENITY_FEE: 'AMENITY_FEE',
    APPLICATION_FEE: 'APPLICATION_FEE',
    CABLE_SERVICE: 'CABLE_SERVICE',
    CHARGE_CODE_USAGE: 'CHARGE_CODE_USAGE',
    CHECKS_CONFIGRED: 'CHECKS_CONFIGRED',
    CONCESSIONS: 'CONCESSIONS',
    CONCESSIONS_ONE_TIME: 'CONCESSIONS_ONE_TIME',
    CONCESSIONS_MONTHLY: 'CONCESSIONS_MONTHLY',
    CONCESSIONS_OTHER: 'CONCESSIONS_OTHER',
    DOUBLE_OCCUPANCY: 'DOUBLE_OCCUPANCY',
    EARLY_MOVE_IN_FEE: 'EARLY_MOVE_IN_FEE',
    EARLY_TERMINATION_FEE: 'EARLY_TERMINATION_FEE',
    ELECTRIC_SERVICE: 'ELECTRIC_SERVICE',
    FLOOR_PLAN: 'FLOOR_PLAN',
    GAS_SERVICE: 'GAS_SERVICE',
    GREEN_FEE: 'GREEN_FEE',
    GUARANTOR: 'GUARANTOR',
    GUARANTOR_WAIVER_PROGRAM: 'GUARANTOR_WAIVER_PROGRAM',
    IDENTIFICATION_PROVIDED: 'IDENTIFICATION_PROVIDED',
    INSURANCE_ADDENDUM: 'INSURANCE_ADDENDUM',
    RENTERS_INSURANCE: 'RENTERS_INSURANCE',
    LIABILITY_WAIVER: 'LIABILITY_WAIVER',
    INTERNET_SERVICE: 'INTERNET_SERVICE',
    LEASE_BREAK_FEE: 'LEASE_BREAK_FEE',
    LEASE_DOCUMENT_PRESENT: 'LEASE_DOCUMENT_PRESENT',
    LEASE_TERM: 'LEASE_TERM',
    LESSEE: 'LESSEE',
    MONTH_TO_MONTH_PREMIUM: 'MONTH_TO_MONTH_PREMIUM',
    OCCUPANT: 'OCCUPANT',
    PARKING_RENT: 'PARKING_RENT',
    PARKING_FEE: 'PARKING_FEE',
    PARKING_CHARGES: 'PARKING_CHARGES',
    PARKING_SPACE: 'PARKING_SPACE',
    CARPORT: 'CARPORT',
    STORAGE: 'STORAGE',
    GARAGE: 'GARAGE',
    PEST_CONTROL: 'PEST_CONTROL',
    PET_DEPOSIT: 'PET_DEPOSIT',
    PET_FEE: 'PET_FEE',
    PET_RENT: 'PET_RENT',
    RENT: 'RENT',
    RENT_INSTALLMENTS: 'RENT_INSTALLMENTS',
    RENT_INCREASE: 'RENT_INCREASE',
    SECURITY_DEPOSIT: 'SECURITY_DEPOSIT',
    SECURITY_DEPOSIT_WAIVER: 'SECURITY_DEPOSIT_WAIVER',
    SEWER_SERVICE: 'SEWER_SERVICE',
    SHORT_TERM_LEASE: 'SHORT_TERM_LEASE',
    STORAGE_RENTAL: 'STORAGE_RENTAL',
    TECHNOLOGY_FEE: 'TECHNOLOGY_FEE',
    TRANSFER_FEE: 'TRANSFER_FEE',
    TRASH_SERVICE: 'TRASH_SERVICE',
    UNIT: 'UNIT',
    UNIT_AMENITY: 'UNIT_AMENITY',
    WATER_SERVICE: 'WATER_SERVICE',
    DEPRECATED: 'DEPRECATED',
};
export const AIIssueNoteVisibility = {
    internal: 'internal',
    customer: 'customer',
};
export const AIIssueStatus = {
    new: 'new',
    in_review: 'in_review',
    accepted: 'accepted',
    rejected: 'rejected',
    needs_customer_input: 'needs_customer_input',
    customer_input_provided: 'customer_input_provided',
};
export const AIIssueSortParam = {
    open_override_count: 'open_override_count',
    '-open_override_count': '-open_override_count',
    closed_override_count: 'closed_override_count',
    '-closed_override_count': '-closed_override_count',
    created_at: 'created_at',
    '-created_at': '-created_at',
    created_by: 'created_by',
    '-created_by': '-created_by',
    assigned_to: 'assigned_to',
    '-assigned_to': '-assigned_to',
    completed_at: 'completed_at',
    '-completed_at': '-completed_at',
    opened_at: 'opened_at',
    '-opened_at': '-opened_at',
};
export const ExternalSystemType = {
    ENTRATA: 'ENTRATA',
    YARDI: 'YARDI',
    AGNOSTIC: 'AGNOSTIC',
};
export const SurfaceCoreSystemEntitiesPropertylicenseLicensedFeature = {
    Core: 'Core',
    LeaseAuditAgent: 'LeaseAuditAgent',
    DelinquencyAgent: 'DelinquencyAgent',
    DueDiligence: 'DueDiligence',
    Transitions: 'Transitions',
    DocumentMigration: 'DocumentMigration',
    DocumentAudit: 'DocumentAudit',
};
export const Action = {
    Full: 'Full',
    Read: 'Read',
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete',
    TaskOpenClose: 'TaskOpenClose',
    GuestUser: 'GuestUser',
};
export const AdditionalDeposit = {
    PET_DEPOSIT: 'PET_DEPOSIT',
};
export const AdjudicationState = {
    correct: 'correct',
    incorrect: 'incorrect',
    maybe_correct: 'maybe_correct',
    maybe_incorrect: 'maybe_incorrect',
    unknown: 'unknown',
};
export const AdministrationFeeCheckConfigurationInputType = {
    AdministrationFeeCheckConfiguration: 'AdministrationFeeCheckConfiguration',
};
export const AdministrationFeeCheckConfigurationOutputType = {
    AdministrationFeeCheckConfiguration: 'AdministrationFeeCheckConfiguration',
};
export const AgentConversationStatus = {
    Active: 'Active',
    Paused: 'Paused',
    Cancelled: 'Cancelled',
};
export const EmailDeliveryStatus = {
    QUEUED: 'QUEUED',
    DRAFT_PENDING_REVIEW: 'DRAFT_PENDING_REVIEW',
    DRAFT_REJECTED: 'DRAFT_REJECTED',
    SENT: 'SENT',
    RECEIVED: 'RECEIVED',
};
export const AgentGuidelineSource = {
    manual: 'manual',
    from_reject: 'from_reject',
    from_edit: 'from_edit',
};
export const AmenityFeeCheckConfigurationType = {
    AmenityFeeCheckConfiguration: 'AmenityFeeCheckConfiguration',
};
export const AmenityUpgradeAddendumInputType = {
    AmenityUpgradeAddendum: 'AmenityUpgradeAddendum',
};
export const IndividualType = {
    Lessee: 'Lessee',
    Occupant: 'Occupant',
    Guarantor: 'Guarantor',
};
export const AmenityUpgradeAddendumOutputType = {
    AmenityUpgradeAddendum: 'AmenityUpgradeAddendum',
};
export const AnimalAddendumInputType = {
    AnimalAddendum: 'AnimalAddendum',
};
export const ChargeFrequency = {
    Once: 'Once',
    Monthly: 'Monthly',
    Weekly: 'Weekly',
    'Bi-Annual': 'Bi-Annual',
    Annual: 'Annual',
};
export const AnimalAddendumOutputType = {
    AnimalAddendum: 'AnimalAddendum',
};
export const AnimalCheckConfigurationType = {
    AnimalCheckConfiguration: 'AnimalCheckConfiguration',
};
export const SurfaceCoreAskEntititesAskentitiesApplicationType = {
    Application: 'Application',
};
export const MakeReadyStatus = {
    Ready: 'Ready',
    Not_Ready: 'Not Ready',
};
export const ApplicationStatus = {
    Started: 'Started',
    Partially_Completed: 'Partially Completed',
    Completed: 'Completed',
    Cancelled: 'Cancelled',
    Reopened: 'Reopened',
    Approved: 'Approved',
    Declined: 'Declined',
    Archived: 'Archived',
};
export const LeaseCompletionStatus = {
    Not_Started: 'Not Started',
    Started: 'Started',
    Partially_Completed: 'Partially Completed',
    Completed: 'Completed',
    Cancelled: 'Cancelled',
    Approved: 'Approved',
    Edited: 'Edited',
    Declined: 'Declined',
};
export const ApplicationType = {
    Application: 'Application',
    Lease_Transfer: 'Lease Transfer',
    Renewal: 'Renewal',
};
export const LeaseCommitmentType = {
    Month_to_Month: 'Month to Month',
    Fixed: 'Fixed',
};
export const TaskStatus = {
    Completed: 'Completed',
    Not_Completed: 'Not Completed',
};
export const SurfaceCoreCoreEntitiesScreeningDecision = {
    Approved: 'Approved',
    Approve_With_Conditions: 'Approve With Conditions',
    Denied: 'Denied',
    Pending: 'Pending',
};
export const SurfaceCoreAskEntititesAskentitiesUnitType = {
    Unit: 'Unit',
};
export const OccupancyStatus = {
    Vacant: 'Vacant',
    Occupied: 'Occupied',
    On_Notice: 'On Notice',
};
export const AvailabilityStatus = {
    Available: 'Available',
    Unavailable: 'Unavailable',
};
export const FloorPlanType = {
    FloorPlan: 'FloorPlan',
};
export const SurfaceCoreAskEntititesAskentitiesLeaseType = {
    Lease: 'Lease',
};
export const LeasePaymentStatus = {
    Current: 'Current',
    In_Collections: 'In Collections',
};
export const LeaseDepartureIntent = {
    None: 'None',
    Notice: 'Notice',
    Renewed: 'Renewed',
    Transferred: 'Transferred',
};
export const ResidentTypeProperty = {
    Resident: 'Resident',
};
export const PolicyType = {
    Policy: 'Policy',
};
export const SurfaceCoreAskEntititesAskentitiesMoveInType = {
    MoveIn: 'MoveIn',
};
export const SurfaceCoreAskEntititesAskentitiesMoveOutType = {
    MoveOut: 'MoveOut',
};
export const LeaseTypeOutput = {
    Lease: 'Lease',
    Renewal: 'Renewal',
};
export const LeaseAuditValueFormat = {
    text: 'text',
    currency: 'currency',
    dates: 'dates',
};
export const LeaseAuditOverrideType = {
    system: 'system',
    user: 'user',
};
export const LeaseAuditCheckOverallOverrideStatus = {
    Directly_Overridden: 'Directly_Overridden',
    Requested: 'Requested',
    Approved: 'Approved',
    Denied: 'Denied',
    Deleted: 'Deleted',
};
export const LeaseAuditCheckOverrideStatus = {
    Requested: 'Requested',
    Approved: 'Approved',
    Denied: 'Denied',
};
export const FinancialImpactDetailStatus = {
    open: 'open',
    excluded: 'excluded',
    fixed: 'fixed',
    zero: 'zero',
};
export const LeadType = {
    Lead: 'Lead',
};
export const GuestCardStatus = {
    Completed: 'Completed',
    Cancelled: 'Cancelled',
    Archived: 'Archived',
};
export const TourType = {
    Tour: 'Tour',
};
export const CommunicationTypeProperty = {
    Communication: 'Communication',
};
export const CommunicationType = {
    Voicemail: 'Voicemail',
    Email: 'Email',
    Text: 'Text',
    Phone: 'Phone',
};
export const LeasingAgentActivityType = {
    LeasingAgentActivity: 'LeasingAgentActivity',
};
export const AskLeaseAuditSummaryType = {
    AskLeaseAuditSummary: 'AskLeaseAuditSummary',
};
export const LeaseAuditFailureExplanationType = {
    LeaseAuditFailureExplanation: 'LeaseAuditFailureExplanation',
};
export const ApplicantInputType = {
    Applicant: 'Applicant',
};
export const ApplicantType = {
    Resident: 'Resident',
    Guarantor: 'Guarantor',
};
export const IncomeFrequency = {
    Monthly: 'Monthly',
    Annually: 'Annually',
};
export const ScreeningResult = {
    Passed: 'Passed',
    Pass_With_Conditions: 'Pass With Conditions',
    Failed: 'Failed',
    Pending: 'Pending',
};
export const SurfaceCoreApiDocumentprofileentitiesScreeningDecision = {
    Approved: 'Approved',
    Approve_With_Conditions: 'Approve With Conditions',
    Denied: 'Denied',
    Pending: 'Pending',
};
export const ScreeningCondition = {
    Add_Guarantor: 'Add Guarantor',
    Guarantor_Waiver_Program: 'Guarantor Waiver Program',
    Additional_Deposit: 'Additional Deposit',
};
export const ApplicationInputType = {
    Application: 'Application',
};
export const ApplicationFeeCheckConfigurationInputType = {
    ApplicationFeeCheckConfiguration: 'ApplicationFeeCheckConfiguration',
};
export const ApplicationFeeCheckConfigurationOutputType = {
    ApplicationFeeCheckConfiguration: 'ApplicationFeeCheckConfiguration',
};
export const ArchetypeMaturity = {
    immature: 'immature',
    mature: 'mature',
};
export const ArchetypePolicyOverride = {
    none: 'none',
    force_on: 'force_on',
    force_off: 'force_off',
};
export const AssignTaskToPropertyManagerActionConfigType = {
    AssignTaskToPropertyManagerAction: 'AssignTaskToPropertyManagerAction',
};
export const FixedDayOfMonthType = {
    FixedDayOfMonth: 'FixedDayOfMonth',
};
export const DaysAfterCompletedActionType = {
    DaysAfterCompletedAction: 'DaysAfterCompletedAction',
};
export const WhenCreatedType = {
    WhenCreated: 'WhenCreated',
};
export const DaysAfterTaskCreatedType = {
    DaysAfterTaskCreated: 'DaysAfterTaskCreated',
};
export const CompanyRole = {
    Owner: 'Owner',
    FromManager: 'FromManager',
    ToManager: 'ToManager',
    FromOwner: 'FromOwner',
    ToOwner: 'ToOwner',
};
export const AuditConfigurationInputType = {
    AuditConfiguration: 'AuditConfiguration',
};
export const ChargeSource = {
    LEASE: 'LEASE',
    LEDGER: 'LEDGER',
    LEASE_FIRST: 'LEASE_FIRST',
    LEDGER_FIRST: 'LEDGER_FIRST',
    BOTH: 'BOTH',
};
export const ConcessionCheckConfigurationType = {
    ConcessionCheckConfiguration: 'ConcessionCheckConfiguration',
};
export const PetFeeCheckConfigurationInputType = {
    PetFeeCheckConfiguration: 'PetFeeCheckConfiguration',
};
export const UnitAmenityCheckConfigurationType = {
    UnitAmenityCheckConfiguration: 'UnitAmenityCheckConfiguration',
};
export const IndividualCheckConfigurationType = {
    IndividualCheckConfiguration: 'IndividualCheckConfiguration',
};
export const LeaseUnitCheckConfigurationType = {
    LeaseUnitCheckConfiguration: 'LeaseUnitCheckConfiguration',
};
export const RentCheckConfigurationType = {
    RentCheckConfiguration: 'RentCheckConfiguration',
};
export const RentCheckConfigurationIncludeChargesInDocumentRentAmount = {
    include: 'include',
    exclude: 'exclude',
    both: 'both',
};
export const RentCheckConfigurationDocumentRentAmountValidation = {
    includes_concessions: 'includes_concessions',
    excludes_concessions: 'excludes_concessions',
    both: 'both',
};
export const ShortTermLeaseCheckConfigurationType = {
    ShortTermLeaseCheckConfiguration: 'ShortTermLeaseCheckConfiguration',
};
export const LeaseTermCheckConfigurationType = {
    LeaseTermCheckConfiguration: 'LeaseTermCheckConfiguration',
};
export const LeaseTermCheckConfigurationTermDatesMatchMode = {
    both: 'both',
    start_date_only: 'start_date_only',
    end_date_only: 'end_date_only',
};
export const SecurityDepositCheckConfigurationType = {
    SecurityDepositCheckConfiguration: 'SecurityDepositCheckConfiguration',
};
export const ParkingCheckConfigurationType = {
    ParkingCheckConfiguration: 'ParkingCheckConfiguration',
};
export const SpaceChargeCheckConfigurationType = {
    SpaceChargeCheckConfiguration: 'SpaceChargeCheckConfiguration',
};
export const ChargeCodeCheckConfigurationType = {
    ChargeCodeCheckConfiguration: 'ChargeCodeCheckConfiguration',
};
export const IdentificationProvidedCheckConfigurationType = {
    IdentificationProvidedCheckConfiguration: 'IdentificationProvidedCheckConfiguration',
};
export const UtilityServiceCheckConfigurationType = {
    UtilityServiceCheckConfiguration: 'UtilityServiceCheckConfiguration',
};
export const UtilityBillingType = {
    fixed: 'fixed',
    usage_based: 'usage_based',
};
export const TechnologyFeeCheckConfigurationType = {
    TechnologyFeeCheckConfiguration: 'TechnologyFeeCheckConfiguration',
};
export const StorageRentalCheckConfigurationType = {
    StorageRentalCheckConfiguration: 'StorageRentalCheckConfiguration',
};
export const GreenFeeCheckConfigurationType = {
    GreenFeeCheckConfiguration: 'GreenFeeCheckConfiguration',
};
export const EarlyMoveInCheckConfigurationType = {
    EarlyMoveInCheckConfiguration: 'EarlyMoveInCheckConfiguration',
};
export const DoubleOccupancyCheckConfigurationType = {
    DoubleOccupancyCheckConfiguration: 'DoubleOccupancyCheckConfiguration',
};
export const PetRentCheckConfigurationType = {
    PetRentCheckConfiguration: 'PetRentCheckConfiguration',
};
export const LeaseDocumentPresentCheckConfigurationType = {
    LeaseDocumentPresentCheckConfiguration: 'LeaseDocumentPresentCheckConfiguration',
};
export const GuarantorProgramCheckConfigurationType = {
    GuarantorProgramCheckConfiguration: 'GuarantorProgramCheckConfiguration',
};
export const SecurityDepositWaiverCheckConfigurationType = {
    SecurityDepositWaiverCheckConfiguration: 'SecurityDepositWaiverCheckConfiguration',
};
export const CheckCheckConfigurationType = {
    CheckCheckConfiguration: 'CheckCheckConfiguration',
};
export const RentInstallmentCheckConfigurationType = {
    RentInstallmentCheckConfiguration: 'RentInstallmentCheckConfiguration',
};
export const InsuranceCheckConfigurationType = {
    InsuranceCheckConfiguration: 'InsuranceCheckConfiguration',
};
export const InsuranceAuditScenario = {
    renters_or_forced_liability_placement: 'renters_or_forced_liability_placement',
    forced_liability_placement: 'forced_liability_placement',
};
export const MonthToMonthPremiumCheckConfigurationType = {
    MonthToMonthPremiumCheckConfiguration: 'MonthToMonthPremiumCheckConfiguration',
};
export const RentIncreaseCheckConfigurationType = {
    RentIncreaseCheckConfiguration: 'RentIncreaseCheckConfiguration',
};
export const FloorPlanCheckConfigurationType = {
    FloorPlanCheckConfiguration: 'FloorPlanCheckConfiguration',
};
export const LeaseStage = {
    Past: 'Past',
    Current: 'Current',
    Future: 'Future',
    Offered: 'Offered',
    Cancelled: 'Cancelled',
};
export const DynamicCheckConfigurationType = {
    DynamicCheckConfiguration: 'DynamicCheckConfiguration',
};
export const ChargeType = {
    Amenity_Fee: 'Amenity Fee',
    Amenity_Upgrade: 'Amenity Upgrade',
    Amenity_Rental: 'Amenity Rental',
    Administrative_Fee: 'Administrative Fee',
    Application_Fee: 'Application Fee',
    Concession: 'Concession',
    Cable_Service: 'Cable Service',
    Electricity: 'Electricity',
    Building_Protection_Fee: 'Building Protection Fee',
    Garage_Unit_Rental: 'Garage Unit Rental',
    Gas_Service: 'Gas Service',
    Guarantor_Waiver_Default_Fee: 'Guarantor Waiver Default Fee',
    Guarantor_Waiver_Fee: 'Guarantor Waiver Fee',
    Internet_Service: 'Internet Service',
    Liability_Waiver: 'Liability Waiver',
    Month_to_Month_Premium: 'Month to Month Premium',
    Pest_Control: 'Pest Control',
    Pet_Fee: 'Pet Fee',
    Pet_Rent: 'Pet Rent',
    Pet_Deposit: 'Pet Deposit',
    Rent: 'Rent',
    Reserved_Parking: 'Reserved Parking',
    Security_Deposit: 'Security Deposit',
    Security_Deposit_Waiver_Fee: 'Security Deposit Waiver Fee',
    Storage_Rental: 'Storage Rental',
    Technology_Fee: 'Technology Fee',
    Sewer_Service: 'Sewer Service',
    Trash_Service: 'Trash Service',
    Utility_Admin_Fee: 'Utility Admin Fee',
    Water_Utility: 'Water Utility',
    'Early_Move-In_Fees': 'Early Move-In Fees',
    'Short-Term_Lease_Premium': 'Short-Term Lease Premium',
    Double_Occupancy_Premium: 'Double Occupancy Premium',
    Green_Fee: 'Green Fee',
    Deposit_Premium_Conditional: 'Deposit Premium Conditional',
    Unmapped: 'Unmapped',
};
export const CheckFailureType = {
    charge_not_found_in_rent_roll: 'charge_not_found_in_rent_roll',
    charge_not_found_in_lease_document: 'charge_not_found_in_lease_document',
    undercharged_amount: 'undercharged_amount',
    overcharged_amount: 'overcharged_amount',
    deposit_not_found_in_rent_roll: 'deposit_not_found_in_rent_roll',
    deposit_not_found_in_lease_document: 'deposit_not_found_in_lease_document',
    underdeposited_amount: 'underdeposited_amount',
    overdeposited_amount: 'overdeposited_amount',
    concession_not_found_in_rent_roll: 'concession_not_found_in_rent_roll',
    concession_not_found_in_lease_document: 'concession_not_found_in_lease_document',
    underapplied_concession_amount: 'underapplied_concession_amount',
    overapplied_concession_amount: 'overapplied_concession_amount',
    lease_date_mismatch: 'lease_date_mismatch',
    unit_number_mismatch: 'unit_number_mismatch',
    floor_plan_mismatch: 'floor_plan_mismatch',
    floor_plan_not_found_in_lease_document: 'floor_plan_not_found_in_lease_document',
    lessee_missing_from_lease_document: 'lessee_missing_from_lease_document',
    lessee_missing_from_rent_roll: 'lessee_missing_from_rent_roll',
    occupant_missing_from_lease_document: 'occupant_missing_from_lease_document',
    occupant_missing_from_rent_roll: 'occupant_missing_from_rent_roll',
    guarantor_missing_from_lease_document: 'guarantor_missing_from_lease_document',
    guarantor_missing_from_rent_roll: 'guarantor_missing_from_rent_roll',
    lease_document_missing: 'lease_document_missing',
    lease_document_not_signed: 'lease_document_not_signed',
    rent_increase_below_threshold: 'rent_increase_below_threshold',
    rent_increase_above_threshold: 'rent_increase_above_threshold',
    rent_installment_amount_mismatch: 'rent_installment_amount_mismatch',
    identification_not_provided: 'identification_not_provided',
    no_proof_of_insurance_found: 'no_proof_of_insurance_found',
    no_charge_found_for_lack_of_insurance: 'no_charge_found_for_lack_of_insurance',
    incorrect_insurance_provider: 'incorrect_insurance_provider',
    no_checks_configured: 'no_checks_configured',
    addendum_not_found: 'addendum_not_found',
    invalid_charge_code_usage: 'invalid_charge_code_usage',
    incomplete_security_deposit_alternative: 'incomplete_security_deposit_alternative',
};
export const CheckFailurePriority = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
};
export const AuditConfigurationOutputType = {
    AuditConfiguration: 'AuditConfiguration',
};
export const PetFeeCheckConfigurationOutputType = {
    PetFeeCheckConfiguration: 'PetFeeCheckConfiguration',
};
export const AuditExplanationStatus = {
    Pending: 'Pending',
    Completed: 'Completed',
    Failed: 'Failed',
};
export const AuditExplanationFeedback = {
    HELPFUL: 'HELPFUL',
    NOT_HELPFUL: 'NOT_HELPFUL',
    NO_VOTE: 'NO_VOTE',
};
export const AuditFilterType = {
    Failed_Audits: 'Failed_Audits',
    No_Previous_Audits: 'No_Previous_Audits',
    No_Previous_Audits_Or_Previous_Failed_Audits: 'No_Previous_Audits_Or_Previous_Failed_Audits',
    Previous_Passed_Audits: 'Previous_Passed_Audits',
    Any_Criteria: 'Any_Criteria',
    Unknown: 'Unknown',
};
export const AuthProvider = {
    microsoft: 'microsoft',
    google: 'google',
    okta: 'okta',
};
export const AuthStatus = {
    disconnected: 'disconnected',
    authenticating: 'authenticating',
    awaiting_mfa: 'awaiting_mfa',
    connected: 'connected',
    failed: 'failed',
};
export const AutoReextractActionFilter = {
    eligible_not_opted_in: 'eligible_not_opted_in',
    eligible_opted_in: 'eligible_opted_in',
    explicitly_opted_out: 'explicitly_opted_out',
    not_eligible: 'not_eligible',
};
export const BankStatementType = {
    BankStatement: 'BankStatement',
};
export const BatchLimitKind = {
    enqueued_tokens: 'enqueued_tokens',
    requests_per_minute: 'requests_per_minute',
    tokens_per_minute: 'tokens_per_minute',
    requests_per_day: 'requests_per_day',
    concurrent_batches: 'concurrent_batches',
    billing_quota: 'billing_quota',
    other: 'other',
};
export const BillingBasis = {
    FLAT: 'FLAT',
    PER_VEHICLE: 'PER_VEHICLE',
    PER_SPACE: 'PER_SPACE',
};
export const TaskPriority = {
    low: 'low',
    medium: 'medium',
    high: 'high',
    very_high: 'very_high',
};
export const CardValueType = {
    count: 'count',
    currency: 'currency',
    percent: 'percent',
    number: 'number',
    boolean: 'boolean',
    text: 'text',
};
export const ChargeMappingSource = {
    property: 'property',
    tenant: 'tenant',
    enum: 'enum',
    global: 'global',
    regex: 'regex',
    unmapped: 'unmapped',
};
export const ConcessionType = {
    One_Time: 'One Time',
    Monthly: 'Monthly',
    Other: 'Other',
};
export const ConcessionMethod = {
    Discounted_Amount: 'Discounted Amount',
    Waived_Fee: 'Waived Fee',
    Deferred_Amount: 'Deferred Amount',
    Gift_Card: 'Gift Card',
};
export const ConditionalInsuranceChargeCondition = {
    Failure_to_Secure_Coverage: 'Failure to Secure Coverage',
    Other: 'Other',
};
export const ConfigSortParam = {
    created_date: 'created_date',
    '-created_date': '-created_date',
    updated_date: 'updated_date',
    '-updated_date': '-updated_date',
    property_id: 'property_id',
    '-property_id': '-property_id',
    config_type: 'config_type',
    '-config_type': '-config_type',
    branch_name: 'branch_name',
    '-branch_name': '-branch_name',
};
export const ConnectionStatus = {
    disconnected: 'disconnected',
    active: 'active',
    error: 'error',
};
export const ProductChargeFrequency = {
    Monthly: 'Monthly',
    Once: 'Once',
    When_Utilized: 'When Utilized',
};
export const EvalTaskType = {
    document_indexing: 'document_indexing',
};
export const SamplingAllocation = {
    proportional: 'proportional',
    balanced: 'balanced',
    explicit: 'explicit',
};
export const SurfaceCoreAuditingServicesLeaseaudittargetingserviceLeaseType = {
    Any: 'Any',
    Current: 'Current',
    Future: 'Future',
    Current_And_Future: 'Current_And_Future',
    Past: 'Past',
    Unknown: 'Unknown',
};
export const RenewalType = {
    Any: 'Any',
    No_Renewals: 'No_Renewals',
    Only_Renewals: 'Only_Renewals',
    Unknown: 'Unknown',
};
export const EmploymentStatus = {
    Employed: 'Employed',
    Unemployed: 'Unemployed',
    Retired: 'Retired',
    Student: 'Student',
    Minor: 'Minor',
    Unknown: 'Unknown',
};
export const UnemployedSourceOfIncome = {
    'Social_Security/Disability': 'Social Security/Disability',
    Retirement: 'Retirement',
    Alimony: 'Alimony',
    Savings: 'Savings',
    Supported_by_Parents: 'Supported by Parents',
    Trust_Fund: 'Trust Fund',
    Other: 'Other',
    Unknown: 'Unknown',
};
export const DailyReportInterval = {
    today: 'today',
    'today-1': 'today-1',
    'today-2': 'today-2',
    'today-3': 'today-3',
    'today-4': 'today-4',
    'today-5': 'today-5',
    'today-6': 'today-6',
    'today-7': 'today-7',
};
export const DashboardCardDeltaType = {
    absolute: 'absolute',
    percent: 'percent',
};
export const DashboardCardDeltaDirection = {
    up: 'up',
    down: 'down',
    flat: 'flat',
};
export const SendTextNoticeActionConfigType = {
    SendTextNoticeAction: 'SendTextNoticeAction',
};
export const SendEmailNoticeActionConfigType = {
    SendEmailNoticeAction: 'SendEmailNoticeAction',
};
export const SendCertifiedLetterNoticeActionConfigType = {
    SendCertifiedLetterNoticeAction: 'SendCertifiedLetterNoticeAction',
};
export const PlaceNoticeOnDoorActionConfigType = {
    PlaceNoticeOnDoorAction: 'PlaceNoticeOnDoorAction',
};
export const RequestEvictionHearingByEmailActionConfigType = {
    RequestEvictionHearingByEmailAction: 'RequestEvictionHearingByEmailAction',
};
export const WaiveLateFeeActionConfigType = {
    WaiveLateFeeAction: 'WaiveLateFeeAction',
};
export const ExtendEvictionTimelineActionConfigType = {
    ExtendEvictionTimelineAction: 'ExtendEvictionTimelineAction',
};
export const RecordEvictionCourtDateActionConfigType = {
    RecordEvictionCourtDateAction: 'RecordEvictionCourtDateAction',
};
export const DelinquencyAgentProcessConfigInputType = {
    DelinquencyAgentProcessConfig: 'DelinquencyAgentProcessConfig',
};
export const DelinquencyAgentProcessConfigOutputType = {
    DelinquencyAgentProcessConfig: 'DelinquencyAgentProcessConfig',
};
export const DelinquencyProcessConfigInputType = {
    DelinquencyProcessConfig: 'DelinquencyProcessConfig',
};
export const DelinquencyProcessConfigOutputType = {
    DelinquencyProcessConfig: 'DelinquencyProcessConfig',
};
export const ReportDimensionDefType = {
    string: 'string',
    integer: 'integer',
    number: 'number',
    boolean: 'boolean',
    date: 'date',
    datetime: 'datetime',
};
export const ReportMeasureDefType = {
    count: 'count',
    currency: 'currency',
    percent: 'percent',
    number: 'number',
    duration: 'duration',
};
export const ReportMeasureDefAggregation = {
    sum: 'sum',
    avg: 'avg',
    min: 'min',
    max: 'max',
    count: 'count',
    latest: 'latest',
};
export const DoctorsNoteType = {
    DoctorsNote: 'DoctorsNote',
};
export const DocumentAccess = {
    ReadMetadata: 'ReadMetadata',
    ReadContents: 'ReadContents',
    Manage: 'Manage',
};
export const DocumentArchiveStatus = {
    active: 'active',
    archived: 'archived',
    any: 'any',
};
export const DocumentClassification = {
    Administrative_Checklist: 'Administrative Checklist',
    Amenity_Upgrade_Addendum: 'Amenity Upgrade Addendum',
    Animal_Addendum: 'Animal Addendum',
    Application: 'Application',
    Guest_Card: 'Guest Card',
    Doctors_Note: 'Doctors Note',
    'Early_Move-In_Addendum': 'Early Move-In Addendum',
    Email: 'Email',
    Final_Bill: 'Final Bill',
    Utility_Bill: 'Utility Bill',
    Guaranty_Agreement: 'Guaranty Agreement',
    Housing_Assistance_Payments_Contract: 'Housing Assistance Payments Contract',
    Incident_Report: 'Incident Report',
    Identification_Document: 'Identification Document',
    ID_Verification_Results: 'ID Verification Results',
    Insurance_Addendum: 'Insurance Addendum',
    Lead_Paint_Disclosure: 'Lead Paint Disclosure',
    Bank_Statement: 'Bank Statement',
    Pay_Statement: 'Pay Statement',
    Lease: 'Lease',
    Lease_Disclosure: 'Lease Disclosure',
    Ledger: 'Ledger',
    Notice_Letter: 'Notice Letter',
    Parking_Addendum: 'Parking Addendum',
    Proof_of_Insurance: 'Proof of Insurance',
    Proof_of_Utility_Service: 'Proof of Utility Service',
    Renewal_Lease: 'Renewal Lease',
    Renewal_Offer: 'Renewal Offer',
    Rent_Concession: 'Rent Concession',
    Restricted_Pet_Breed_List: 'Restricted Pet Breed List',
    Roommate_Amendment: 'Roommate Amendment',
    Screening_Decision_Letter: 'Screening Decision Letter',
    Security_Deposit_Waiver_Addendum: 'Security Deposit Waiver Addendum',
    Service_Animal_Addendum: 'Service Animal Addendum',
    'Short-Term_Lease_Addendum': 'Short-Term Lease Addendum',
    Spreadsheet: 'Spreadsheet',
    Utility_Addendum: 'Utility Addendum',
    Welcome_Letter: 'Welcome Letter',
    Unrecognized: 'Unrecognized',
    Unrecognized_Image: 'Unrecognized Image',
    Policy_Document: 'Policy Document',
};
export const TransitionDocumentClassification = {
    Property_T12: 'Property T12',
    Property_W9: 'Property W9',
    Vendor_Invoice: 'Vendor Invoice',
    Vendor_Agreement: 'Vendor Agreement',
    Property_Certificate_of_Insurance: 'Property Certificate of Insurance',
    Mortgage_Loan_Agreement: 'Mortgage Loan Agreement',
    Mortgage_Promissory_Note: 'Mortgage Promissory Note',
    Mortgage_Statement: 'Mortgage Statement',
    Mortgage_Amortization_Schedule: 'Mortgage Amortization Schedule',
    Lender_Contact_Information: 'Lender Contact Information',
    Property_Contact_Information: 'Property Contact Information',
    Management_Contact_Information: 'Management Contact Information',
    Management_Agreement: 'Management Agreement',
    Management_Agents_Certification_HUD_9839B: 'Management Agents Certification HUD 9839B',
    Owner_Contact_Information: 'Owner Contact Information',
    HUD_Rent_Schedule: 'HUD Rent Schedule',
    'HUD-50059': 'HUD-50059',
    HUD_Repayment_Agreement: 'HUD Repayment Agreement',
    Rent_Roll_Report: 'Rent Roll Report',
    Resident_Demographic_Report: 'Resident Demographic Report',
    Vendor_List: 'Vendor List',
    Affirmative_Fair_Housing_Marketing_Plan: 'Affirmative Fair Housing Marketing Plan',
    Tenant_Selection_Plan: 'Tenant Selection Plan',
    EIN_Confirmation: 'EIN Confirmation',
    ACH_Authorization_Form: 'ACH Authorization Form',
    ALTA_Survey: 'ALTA Survey',
    Achieved_Renewal_Rent_Report: 'Achieved Renewal Rent Report',
    Achieved_Rent_Report: 'Achieved Rent Report',
    Affordable_Housing_Compliance_Certification: 'Affordable Housing Compliance Certification',
    Aged_Delinquency_Report: 'Aged Delinquency Report',
    Balcony_Inspection_Report: 'Balcony Inspection Report',
    Bank_Wiring_Instructions: 'Bank Wiring Instructions',
    Borrower_Information_Sheet: 'Borrower Information Sheet',
    Business_License: 'Business License',
    CMTS_Filing_Agreement: 'CMTS Filing Agreement',
    Capital_Project_Document: 'Capital Project Document',
    Certificate_of_Formation: 'Certificate of Formation',
    Certificate_of_Occupancy: 'Certificate of Occupancy',
    Credit_and_Background_Authorization: 'Credit and Background Authorization',
    'Debarment_Affidavit/Certification': 'Debarment Affidavit/Certification',
    Delegated_Administrator_Agreement: 'Delegated Administrator Agreement',
    Environmental_Site_Assessment: 'Environmental Site Assessment',
    Evictions_Report: 'Evictions Report',
    'Executive_Resume/Bio': 'Executive Resume/Bio',
    FEHO_Long_Form: 'FEHO Long Form',
    Fair_Housing_Compliance_Questionnaire: 'Fair Housing Compliance Questionnaire',
    'Financial_Report_Sample/Submission': 'Financial Report Sample/Submission',
    Policies_and_Procedures: 'Policies and Procedures',
    HFA_Previous_Participation_Certification: 'HFA Previous Participation Certification',
    HUD_2530_Approval_Letter: 'HUD 2530 Approval Letter',
    HUD_2530_Submission_Package: 'HUD 2530 Submission Package',
    HUD_HAP_Contract: 'HUD HAP Contract',
    HUD_HAP_Voucher: 'HUD HAP Voucher',
    HUD_MOR_Closure_Letter: 'HUD MOR Closure Letter',
    HUD_MOR_Inspection_Report: 'HUD MOR Inspection Report',
    HUD_RCS_Approval_Letter: 'HUD RCS Approval Letter',
    HUD_REAC_Inspection_Report: 'HUD REAC Inspection Report',
    HUD_REAC_Response_Letter: 'HUD REAC Response Letter',
    HUD_Regulatory_Agreement: 'HUD Regulatory Agreement',
    HUD_Section_8_Tax_Credit_Agreement: 'HUD Section 8 Tax Credit Agreement',
    'IRS_Form_SS-4_(EIN_Application)': 'IRS Form SS-4 (EIN Application)',
    Insurance_Loss_Run: 'Insurance Loss Run',
    Investor_Compliance_Form: 'Investor Compliance Form',
    'Investor/Lender_Submission_Package': 'Investor/Lender Submission Package',
    LIHTC_Application: 'LIHTC Application',
    'LIHTC_Binding_Commitment_/_42M_Letter': 'LIHTC Binding Commitment / 42M Letter',
    'LIHTC_Form_8609_/_8609-A': 'LIHTC Form 8609 / 8609-A',
    LIHTC_Cost_Certification: 'LIHTC Cost Certification',
    LIHTC_Gross_Rent_Floor_Election: 'LIHTC Gross Rent Floor Election',
    LIHTC_Qualified_Basis_Tracking_Sheet: 'LIHTC Qualified Basis Tracking Sheet',
    LIHTC_Excess_Income_Report: 'LIHTC Excess Income Report',
    Testing_Notice: 'Testing Notice',
    Testing_Unit_Selection: 'Testing Unit Selection',
    Lease_Expiration_Report: 'Lease Expiration Report',
    Lease_Transaction_Summary: 'Lease Transaction Summary',
    Lease_Addendum: 'Lease Addendum',
    Lease_Renewal_Workbook: 'Lease Renewal Workbook',
    Limited_Partnership_Agreement: 'Limited Partnership Agreement',
    Management_Agreement_Addendum: 'Management Agreement Addendum',
    Management_Company_Corporate_Profile: 'Management Company Corporate Profile',
    Management_Company_Profile_Questionnaire: 'Management Company Profile Questionnaire',
    Management_Plan: 'Management Plan',
    Management_Termination_Letter: 'Management Termination Letter',
    Property_Portfolio_List: 'Property Portfolio List',
    Market_Survey: 'Market Survey',
    Market_and_Actual_Rent_Report: 'Market and Actual Rent Report',
    'Operating_Cost_Adjustment_Factor_(OCAF)_Rent_Schedule': 'Operating Cost Adjustment Factor (OCAF) Rent Schedule',
    New_Property_Information_Survey: 'New Property Information Survey',
    Offering_Memorandum: 'Offering Memorandum',
    'Ownership/Management_Change_Form': 'Ownership/Management Change Form',
    Personal_Property_List: 'Personal Property List',
    Pool_and_Spa_Permit: 'Pool and Spa Permit',
    Property_Closing_Documentation: 'Property Closing Documentation',
    Property_Audit_Report: 'Property Audit Report',
    Property_Amenities_List: 'Property Amenities List',
    'Property_Condition_/_Compliance_Document': 'Property Condition / Compliance Document',
    Property_Executive_Summary: 'Property Executive Summary',
    Property_Floorplans: 'Property Floorplans',
    Property_Logo: 'Property Logo',
    Property_Marketing_Plan: 'Property Marketing Plan',
    Property_Occupancy_Report: 'Property Occupancy Report',
    Property_Organization_Chart: 'Property Organization Chart',
    Property_Photos: 'Property Photos',
    Property_Presentation: 'Property Presentation',
    Property_Staffing_Plan: 'Property Staffing Plan',
    Property_Tax_Bill: 'Property Tax Bill',
    REO_Schedule: 'REO Schedule',
    Real_Estate_Broker_License: 'Real Estate Broker License',
    Rental_Application_and_Criteria: 'Rental Application and Criteria',
    Resident_Communication_Template: 'Resident Communication Template',
    Resident_Lease_Agreement: 'Resident Lease Agreement',
    Resident_Waitlist: 'Resident Waitlist',
    Tenant_Income_Certification: 'Tenant Income Certification',
    SAM_UEI_Registration: 'SAM UEI Registration',
    'Sample/Model_Lease_Template': 'Sample/Model Lease Template',
    Security_Deposit_Report: 'Security Deposit Report',
    Site_Plan: 'Site Plan',
    'State_HFA_/_Non-HUD_Management_Agent_Certification': 'State HFA / Non-HUD Management Agent Certification',
    State_HFA_Agreement: 'State HFA Agreement',
    State_Management_Change_Form: 'State Management Change Form',
    State_Sample_Document_Package: 'State Sample Document Package',
    State_Tax_Credit_Compliance_Manual: 'State Tax Credit Compliance Manual',
    'State/Agency_Management_Approval_Letter': 'State/Agency Management Approval Letter',
    Tenant_Recertification_Document: 'Tenant Recertification Document',
    Tenant_Verification_Form: 'Tenant Verification Form',
    Title_Commitment: 'Title Commitment',
    Unit_Address_List: 'Unit Address List',
    Unit_Availability_Report: 'Unit Availability Report',
    Unit_Mix_Summary: 'Unit Mix Summary',
    Utility_Allowance_Analysis: 'Utility Allowance Analysis',
    Utility_Summary_Spreadsheet: 'Utility Summary Spreadsheet',
    Utility_Meter_Numbers: 'Utility Meter Numbers',
    Utility_Statement: 'Utility Statement',
    ILS_Agreement: 'ILS Agreement',
    Annual_Owner_Certification: 'Annual Owner Certification',
    Backflow_Preventer_Certificate: 'Backflow Preventer Certificate',
    Life_Safety_Inspection_Report: 'Life Safety Inspection Report',
    Life_Safety_Map: 'Life Safety Map',
    Leak_Log: 'Leak Log',
    Branding_Guidelines: 'Branding Guidelines',
    Trial_Balance: 'Trial Balance',
    General_Ledger: 'General Ledger',
    Balance_Sheet: 'Balance Sheet',
    Check_Register: 'Check Register',
    Operating_Budget: 'Operating Budget',
    Resident_Ledger: 'Resident Ledger',
    Accounts_Payable_Aging_Report: 'Accounts Payable Aging Report',
    Bank_Statement: 'Bank Statement',
    Bank_Reconciliation: 'Bank Reconciliation',
    Prepaid_Expense_Schedule: 'Prepaid Expense Schedule',
    Fixed_Asset_Schedule: 'Fixed Asset Schedule',
    Other_Asset_Schedule: 'Other Asset Schedule',
    Intercompany_Schedule: 'Intercompany Schedule',
    Accrued_Expense_Schedule: 'Accrued Expense Schedule',
    Ownership_Advance_Schedule: 'Ownership Advance Schedule',
    Recurring_Journal_Entry_Schedule: 'Recurring Journal Entry Schedule',
    Vehicle_Title_and_Registration: 'Vehicle Title and Registration',
    Service_Provider_Information: 'Service Provider Information',
    Work_Order_Report: 'Work Order Report',
    iREMS_Data_Request_Form: 'iREMS Data Request Form',
    Cabling_Blueprint: 'Cabling Blueprint',
    Telephone_Numbers: 'Telephone Numbers',
    Account_Credentials: 'Account Credentials',
    Elevator_Certificate: 'Elevator Certificate',
    All_Unit_Summary_Report: 'All Unit Summary Report',
    Concession_Report: 'Concession Report',
    Renewal_Report: 'Renewal Report',
    Lease_Charges_Report: 'Lease Charges Report',
    Other_Income_Report: 'Other Income Report',
    Roommate_Report: 'Roommate Report',
    Rentable_Item_Report: 'Rentable Item Report',
    Resident_Contact_List: 'Resident Contact List',
    Payroll_Report: 'Payroll Report',
    Property_Deed: 'Property Deed',
    Intrusion_Alarm_Permit: 'Intrusion Alarm Permit',
    Operating_Permit: 'Operating Permit',
    Building_Permit: 'Building Permit',
    Elevator_Permit: 'Elevator Permit',
    Boiler_Permit: 'Boiler Permit',
    Rental_Permit: 'Rental Permit',
    Business_Licensing_Office_Contact_Information: 'Business Licensing Office Contact Information',
};
export const DocumentContentMetadataPreviewKind = {
    pdf: 'pdf',
    image: 'image',
    text: 'text',
    download: 'download',
};
export const DocumentFileType = {
    PDF: 'PDF',
    JPG: 'JPG',
    PNG: 'PNG',
    DOCX: 'DOCX',
    XLSX: 'XLSX',
    CSV: 'CSV',
    UNDETERMINED: 'UNDETERMINED',
};
export const DocumentInclusionStatus = {
    INCLUDED: 'INCLUDED',
    NOT_INCLUDED: 'NOT_INCLUDED',
};
export const DocumentLeaseMatchStatus = {
    matched: 'matched',
    unmatched: 'unmatched',
};
export const DocumentSensitivityCategory = {
    payroll: 'payroll',
};
export const DocumentSensitivityStatus = {
    pending: 'pending',
    cleared: 'cleared',
    matched_sensitive: 'matched_sensitive',
    quarantined: 'quarantined',
    check_failed: 'check_failed',
};
export const DocumentSourceType = {
    Secure_Upload: 'Secure Upload',
    Sharepoint: 'Sharepoint',
    Email: 'Email',
    Nested_Zip: 'Nested Zip',
};
export const DocumentTaskDocumentInclusionOutcome = {
    candidate: 'candidate',
    approved: 'approved',
    rejected: 'rejected',
    no_longer_matching: 'no_longer_matching',
};
export const Resource = {
    Applications: 'Applications',
    MoveIns: 'MoveIns',
    MoveOuts: 'MoveOuts',
    Renewals: 'Renewals',
    WorkOrders: 'WorkOrders',
    WorkOrdersCorporate: 'WorkOrdersCorporate',
    Delinquency: 'Delinquency',
    Leases: 'Leases',
    Sales: 'Sales',
    Ledgers: 'Ledgers',
    Budgets: 'Budgets',
    Residents: 'Residents',
    Units: 'Units',
    Policies: 'Policies',
    PropertyKPIs: 'PropertyKPIs',
    LeaseAudits: 'LeaseAudits',
    LeaseAuditOverrides: 'LeaseAuditOverrides',
    LeaseAuditOverrideRequests: 'LeaseAuditOverrideRequests',
    LeaseAuditAIIssueRequests: 'LeaseAuditAIIssueRequests',
    LeaseAuditDisallowAudits: 'LeaseAuditDisallowAudits',
    Transitions_Transition: 'Transitions_Transition',
    Transitions_Document: 'Transitions_Document',
    Transitions_DocumentContents: 'Transitions_DocumentContents',
    Transitions_DocumentTask: 'Transitions_DocumentTask',
    Transitions_DocumentRequest: 'Transitions_DocumentRequest',
    Transitions_Collection: 'Transitions_Collection',
    Transitions_Milestone: 'Transitions_Milestone',
    Transitions_Company: 'Transitions_Company',
    Transitions_User: 'Transitions_User',
    Transitions_Template: 'Transitions_Template',
    Transitions_Variable: 'Transitions_Variable',
    Transitions_Note: 'Transitions_Note',
    Transitions_DocRequestAgentConversations: 'Transitions_DocRequestAgentConversations',
    Orders: 'Orders',
    Users: 'Users',
    UserRoles: 'UserRoles',
    DueDiligences: 'DueDiligences',
    Configurations: 'Configurations',
};
export const DocumentTaskDocumentAction = {
    approve: 'approve',
    unapprove: 'unapprove',
    reject: 'reject',
    restore: 'restore',
    re_evaluated: 're_evaluated',
    no_longer_matches: 'no_longer_matches',
};
export const DocumentTaskSortParam = {
    created_at: 'created_at',
    '-created_at': '-created_at',
    updated_at: 'updated_at',
    '-updated_at': '-updated_at',
    name: 'name',
    '-name': '-name',
    target_completion_date: 'target_completion_date',
    '-target_completion_date': '-target_completion_date',
    completed_at: 'completed_at',
    '-completed_at': '-completed_at',
    category: 'category',
    '-category': '-category',
    sequence_number: 'sequence_number',
    '-sequence_number': '-sequence_number',
};
export const EarlyMoveInAddendumInputType = {
    EarlyMoveInAddendum: 'EarlyMoveInAddendum',
};
export const EarlyMoveInAddendumOutputType = {
    EarlyMoveInAddendum: 'EarlyMoveInAddendum',
};
export const JobType = {
    async_poc: 'async_poc',
    audit_config_sync_property: 'audit_config_sync_property',
    backfill_lease_audit_rev_metrics_for_property: 'backfill_lease_audit_rev_metrics_for_property',
    calculate_realized_revenue: 'calculate_realized_revenue',
    convert_file_to_pdf: 'convert_file_to_pdf',
    create_embedding: 'create_embedding',
    create_property_data_from_rentroll: 'create_property_data_from_rentroll',
    dd_lease_audit_export: 'dd_lease_audit_export',
    dd_lease_audit_export_map_reduced: 'dd_lease_audit_export_map_reduced',
    dd_lease_audit_export_stitch: 'dd_lease_audit_export_stitch',
    dd_happyco_profile_data_export: 'dd_happyco_profile_data_export',
    dd_lease_term_backfiller: 'dd_lease_term_backfiller',
    demographic_normalization: 'demographic_normalization',
    lead_event_sync: 'lead_event_sync',
    generate_demo_tenant_data: 'generate_demo_tenant_data',
    documents_migration_to_zip_file: 'documents_migration_to_zip_file',
    document_content_llm_activities: 'document_content_llm_activities',
    document_content_sync: 'document_content_sync',
    document_extraction: 'document_extraction',
    entrata_fetch_application_documents: 'entrata_fetch_application_documents',
    extraction_quality_backfill: 'extraction_quality_backfill',
    fill_sparse_lease_periods_from_docs: 'fill_sparse_lease_periods_from_docs',
    finalize_job_process: 'finalize_job_process',
    force_sync_lease_documents: 'force_sync_lease_documents',
    general_echo: 'general_echo',
    happyco_sync: 'happyco_sync',
    ingest_user_report: 'ingest_user_report',
    lease_audit: 'lease_audit',
    lease_audit_access_revocation: 'lease_audit_access_revocation',
    lease_audit_batch_targeting: 'lease_audit_batch_targeting',
    lease_audit_document_request_refinery: 'lease_audit_document_request_refinery',
    lease_audit_open_tasks_notification: 'lease_audit_open_tasks_notification',
    lease_audit_override_cleanup: 'lease_audit_override_cleanup',
    lease_audit_periodic_reauditor: 'lease_audit_periodic_reauditor',
    lease_audit_post_hoc_mea_culpa: 'lease_audit_post_hoc_mea_culpa',
    lease_audit_hotspot_email: 'lease_audit_hotspot_email',
    lease_audit_report_cache: 'lease_audit_report_cache',
    lease_health_by_property_export: 'lease_health_by_property_export',
    property_health_chart_export: 'property_health_chart_export',
    lease_documents_migration: 'lease_documents_migration',
    lease_stitching: 'lease_stitching',
    lease_sync: 'lease_sync',
    ledger_sync: 'ledger_sync',
    ledger_history_sync: 'ledger_history_sync',
    match_documents_to_leases_from_profiles: 'match_documents_to_leases_from_profiles',
    match_lease_documents: 'match_lease_documents',
    migration_report_export: 'migration_report_export',
    new_tenant: 'new_tenant',
    notification: 'notification',
    pipeline: 'pipeline',
    policy_document_breakdown: 'policy_document_breakdown',
    pms_property_sync: 'pms_property_sync',
    profile_documents_by_classifications: 'profile_documents_by_classifications',
    profile_documents: 'profile_documents',
    profile_single_document: 'profile_single_document',
    trial_document: 'trial_document',
    reconciled_lease_data_publisher: 'reconciled_lease_data_publisher',
    remote_import: 'remote_import',
    reprofile_documents: 'reprofile_documents',
    pms_scrape: 'pms_scrape',
    reindex_lease_docs: 'reindex_lease_docs',
    refresh_lease_document_state: 'refresh_lease_document_state',
    retriable_worker: 'retriable_worker',
    run_eval_experiment: 'run_eval_experiment',
    sample_eval_dataset: 'sample_eval_dataset',
    save_unclassified_lease_documents: 'save_unclassified_lease_documents',
    send_email: 'send_email',
    send_sms: 'send_sms',
    sleepy_echo: 'sleepy_echo',
    test_nested_job: 'test_nested_job',
    transition_document_indexing: 'transition_document_indexing',
    transition_document_matching: 'transition_document_matching',
    transition_document_extraction: 'transition_document_extraction',
    transition_document_profiling: 'transition_document_profiling',
    transition_document_sensitivity_check: 'transition_document_sensitivity_check',
    transition_document_search_export: 'transition_document_search_export',
    transition_task_matching: 'transition_task_matching',
    transition_document_request_agent_session: 'transition_document_request_agent_session',
    orders_agent_session: 'orders_agent_session',
    unassigned: 'unassigned',
    unzip_lease_documents: 'unzip_lease_documents',
    student_lease_term_patch: 'student_lease_term_patch',
};
export const WorkerImageType = {
    pmsfetchingest: 'pmsfetchingest',
    pms_doc_upload: 'pms_doc_upload',
    general_cli: 'general_cli',
    robust_cli: 'robust_cli',
    partitioned_cli: 'partitioned_cli',
    long_running_cli: 'long_running_cli',
    lease_audit_cli: 'lease_audit_cli',
    la_batch_cli: 'la_batch_cli',
    transitions_cli: 'transitions_cli',
    manual_testing: 'manual_testing',
};
export const ServiceAnimalAddendumType = {
    ServiceAnimalAddendum: 'ServiceAnimalAddendum',
};
export const ScreeningDecisionLetterOutputType = {
    ScreeningDecisionLetter: 'ScreeningDecisionLetter',
};
export const SurfaceCoreApiDocumentprofileentitiesApplicationOutputType = {
    Application: 'Application',
};
export const SurfaceCoreApiDocumentprofileentitiesApplicantType = {
    Applicant: 'Applicant',
};
export const GuarantyAgreementType = {
    GuarantyAgreement: 'GuarantyAgreement',
};
export const LeasePacketOutputType = {
    LeasePacket: 'LeasePacket',
};
export const Section = {
    Addendum: 'Addendum',
    Additional_Fee_Sheet: 'Additional Fee Sheet',
    Special_Provisions: 'Special Provisions',
    Main_Agreement: 'Main Agreement',
};
export const SpaceType = {
    PARKING: 'PARKING',
    GARAGE: 'GARAGE',
    CARPORT: 'CARPORT',
    STORAGE: 'STORAGE',
};
export const InsuranceType = {
    Renters: 'Renters',
    Property_Damage_Liability: 'Property Damage Liability',
    Auto: 'Auto',
    Other: 'Other',
};
export const ParkingAddendumOutputType = {
    ParkingAddendum: 'ParkingAddendum',
};
export const ProofOfInsuranceOutputType = {
    ProofOfInsurance: 'ProofOfInsurance',
};
export const RentConcessionAddendumOutputType = {
    RentConcessionAddendum: 'RentConcessionAddendum',
};
export const RoommateAmendmentOutputType = {
    RoommateAmendment: 'RoommateAmendment',
};
export const ShortTermLeaseAddendumOutputType = {
    ShortTermLeaseAddendum: 'ShortTermLeaseAddendum',
};
export const RenewalOfferOutputType = {
    RenewalOffer: 'RenewalOffer',
};
export const TermType = {
    Month_to_Month: 'Month to Month',
    Fixed_Term: 'Fixed Term',
};
export const LeadPaintDisclosureOutputType = {
    LeadPaintDisclosure: 'LeadPaintDisclosure',
};
export const PayStatementType = {
    PayStatement: 'PayStatement',
};
export const IdentificationDocumentType = {
    IdentificationDocument: 'IdentificationDocument',
};
export const UtilityAddendumOutputType = {
    UtilityAddendum: 'UtilityAddendum',
};
export const InsuranceAddendumOutputType = {
    InsuranceAddendum: 'InsuranceAddendum',
};
export const SecurityDepositWaiverAddendumOutputType = {
    SecurityDepositWaiverAddendum: 'SecurityDepositWaiverAddendum',
};
export const GroundTruthIndexedDocumentType = {
    GroundTruthIndexedDocument: 'GroundTruthIndexedDocument',
};
export const EvalEntityType = {
    Indexed_Document: 'Indexed_Document',
    Document_Profile: 'Document_Profile',
};
export const GroundTruthAnimalAddendumType = {
    GroundTruthAnimalAddendum: 'GroundTruthAnimalAddendum',
};
export const GroundTruthServiceAnimalAddendumType = {
    GroundTruthServiceAnimalAddendum: 'GroundTruthServiceAnimalAddendum',
};
export const GroundTruthScreeningDecisionLetterType = {
    GroundTruthScreeningDecisionLetter: 'GroundTruthScreeningDecisionLetter',
};
export const GroundTruthApplicationType = {
    GroundTruthApplication: 'GroundTruthApplication',
};
export const GroundTruthEarlyMoveInAddendumType = {
    GroundTruthEarlyMoveInAddendum: 'GroundTruthEarlyMoveInAddendum',
};
export const GroundTruthGuarantyAgreementType = {
    GroundTruthGuarantyAgreement: 'GroundTruthGuarantyAgreement',
};
export const GroundTruthLeasePacketType = {
    GroundTruthLeasePacket: 'GroundTruthLeasePacket',
};
export const GroundTruthParkingAddendumType = {
    GroundTruthParkingAddendum: 'GroundTruthParkingAddendum',
};
export const GroundTruthProofOfInsuranceType = {
    GroundTruthProofOfInsurance: 'GroundTruthProofOfInsurance',
};
export const GroundTruthRentConcessionAddendumType = {
    GroundTruthRentConcessionAddendum: 'GroundTruthRentConcessionAddendum',
};
export const GroundTruthRoommateAmendmentType = {
    GroundTruthRoommateAmendment: 'GroundTruthRoommateAmendment',
};
export const GroundTruthShortTermLeaseAddendumType = {
    GroundTruthShortTermLeaseAddendum: 'GroundTruthShortTermLeaseAddendum',
};
export const EvalRunType = {
    Ad_Hoc: 'Ad_Hoc',
    Ground_Truth_Only: 'Ground_Truth_Only',
    Mixed: 'Mixed',
};
export const EvalExperimentRunStatus = {
    Pending: 'Pending',
    In_Progress: 'In_Progress',
    Completed: 'Completed',
    Errored: 'Errored',
};
export const InvoiceStatus = {
    Draft: 'Draft',
    Finalized: 'Finalized',
    Void: 'Void',
};
export const InvoiceDeliveryStatus = {
    Not_Sent: 'Not Sent',
    Processing: 'Processing',
    Sent: 'Sent',
};
export const LeaseMigrationDocumentStatus = {
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
};
export const LeaseMigrationStatus = {
    PENDING: 'PENDING',
    QUEUED: 'QUEUED',
    INGESTING: 'INGESTING',
    REVIEW: 'REVIEW',
    PUBLISHING: 'PUBLISHING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
};
export const LeaseMigrationType = {
    PMS_PUBLISH: 'PMS_PUBLISH',
    ZIP_FILE_PUBLISH: 'ZIP_FILE_PUBLISH',
};
export const TransitionDocRequestAgentSettingsType = {
    TransitionDocRequestAgentSettings: 'TransitionDocRequestAgentSettings',
};
export const ProfileConfigurationType = {
    ProfileConfiguration: 'ProfileConfiguration',
};
export const ProfileConfigurationIndexerClass = {
    AnalysisServiceIndexer: 'AnalysisServiceIndexer',
    PageMapIndexer: 'PageMapIndexer',
};
export const NotificationConfigType = {
    NotificationConfig: 'NotificationConfig',
};
export const PMSFetchIngestConfigType = {
    PMSFetchIngestConfig: 'PMSFetchIngestConfig',
};
export const UtilizationPrePurchaseConsumptionUnit = {
    Unit: 'Unit',
    Property: 'Property',
};
export const ExternalJobCallerResolution = {
    resolved: 'resolved',
    missing: 'missing',
    unsupported_kind: 'unsupported_kind',
};
export const ExternalJobProxyResource = {
    status: 'status',
    output: 'output',
    errors: 'errors',
    input_payload: 'input_payload',
    output_payload: 'output_payload',
};
export const PromptDomain = {
    Applications: 'Applications',
    Renewals: 'Renewals',
    Residents: 'Residents',
    Units: 'Units',
    Make_Ready: 'Make Ready',
    Move_Ins: 'Move Ins',
    Move_Outs: 'Move Outs',
    Budget: 'Budget',
    Work_Orders: 'Work Orders',
    Delinquency: 'Delinquency',
    Policies_and_Procedures: 'Policies and Procedures',
    Leases: 'Leases',
    Sales: 'Sales',
    Lease_Audits: 'Lease Audits',
    Unknown: 'Unknown',
};
export const ExtractionQualityClusterReviewOptInScope = {
    tenant: 'tenant',
};
export const ObservationProvenance = {
    live: 'live',
    backfill: 'backfill',
};
export const FindingReviewState = {
    unreviewed: 'unreviewed',
    confirmed_problem: 'confirmed_problem',
    false_positive: 'false_positive',
};
export const InsuranceAddendumInputType = {
    InsuranceAddendum: 'InsuranceAddendum',
};
export const InvoiceSortParam = {
    customer_name: 'customer_name',
    '-customer_name': '-customer_name',
    number: 'number',
    '-number': '-number',
    created_on: 'created_on',
    '-created_on': '-created_on',
    total_amount: 'total_amount',
    '-total_amount': '-total_amount',
    delivery_status: 'delivery_status',
    '-delivery_status': '-delivery_status',
};
export const LeadPaintDisclosureInputType = {
    LeadPaintDisclosure: 'LeadPaintDisclosure',
};
export const LeaseAuditActivityAuditClosedType = {
    audit_closed: 'audit_closed',
};
export const LeaseAuditActivityAuditCreatedAndPassedType = {
    audit_created_and_passed: 'audit_created_and_passed',
};
export const LeaseAuditResult = {
    Pending: 'Pending',
    In_Progress: 'In Progress',
    Passed: 'Passed',
    Failed: 'Failed',
    Resolved: 'Resolved',
    Errored: 'Errored',
    Not_Applicable: 'Not Applicable',
};
export const LeaseAuditActivityAuditCreatedandFailedType = {
    audit_created_and_failed: 'audit_created_and_failed',
};
export const LeaseAuditActivityAuditPassedType = {
    audit_passed: 'audit_passed',
};
export const LeaseAuditActivityCommentAddedType = {
    note_added: 'note_added',
};
export const LeaseAuditActivityNewChecksFailedType = {
    new_checks_failed: 'new_checks_failed',
};
export const LeaseAuditActivityNewChecksPassedType = {
    new_checks_passed: 'new_checks_passed',
};
export const LeaseAuditActivityNewChecksPassedAndFailedType = {
    new_checks_passed_and_failed: 'new_checks_passed_and_failed',
};
export const LeaseAuditActivityOverrideApprovedType = {
    override_approved: 'override_approved',
};
export const LeaseAuditActivityOverrideDeletedType = {
    override_deleted: 'override_deleted',
};
export const LeaseAuditActivityOverrideDeniedType = {
    override_denied: 'override_denied',
};
export const LeaseAuditActivityOverrideDirectType = {
    override_direct: 'override_direct',
};
export const LeaseAuditActivityOverrideRequestedType = {
    override_requested: 'override_requested',
};
export const LeaseAuditActivityOverrideUndoneType = {
    override_undone: 'override_undone',
};
export const LeaseAuditEligibility = {
    Eligible: 'Eligible',
    Ineligible: 'Ineligible',
};
export const LeaseAuditListView = {
    open: 'open',
    closed: 'closed',
    archived: 'archived',
    all: 'all',
};
export const LeaseAuditMedicDocumentContextSource = {
    open_attributed: 'open_attributed',
    latest_inclusion: 'latest_inclusion',
    none: 'none',
};
export const LeaseAuditOnboardingRunStatus = {
    queued: 'queued',
    running: 'running',
    paused: 'paused',
    wrapped: 'wrapped',
    cancelled: 'cancelled',
    failed: 'failed',
};
export const LeaseAuditOverrideStatus = {
    Override_Pending: 'Override_Pending',
    AI_Issue_Pending: 'AI_Issue_Pending',
    Either_Pending: 'Either_Pending',
    None_Pending: 'None_Pending',
    Override_Denied: 'Override_Denied',
    AI_Issue_Denied: 'AI_Issue_Denied',
    Override_Accepted: 'Override_Accepted',
    AI_Issue_Accepted: 'AI_Issue_Accepted',
    AI_Issue_Needs_Customer_Input: 'AI_Issue_Needs_Customer_Input',
};
export const LeaseAuditReportCheckStatusType = {
    fixed: 'fixed',
    fixed_with_override: 'fixed_with_override',
    fixed_without_override: 'fixed_without_override',
    failing_with_override_requested: 'failing_with_override_requested',
    failing_with_override_denied: 'failing_with_override_denied',
};
export const LeaseAuditSortBy = {
    audit_created_date: 'audit_created_date',
    '-audit_created_date': '-audit_created_date',
    run_date_time: 'run_date_time',
    '-run_date_time': '-run_date_time',
    priority: 'priority',
    '-priority': '-priority',
    recoverable_revenue: 'recoverable_revenue',
    '-recoverable_revenue': '-recoverable_revenue',
    assigned_to_current_user_first: 'assigned_to_current_user_first',
};
export const LeaseAuditType = {
    ask: 'ask',
    cli: 'cli',
    api: 'api',
    pms_event: 'pms_event',
    doc_refinement: 'doc_refinement',
    due_diligence: 'due_diligence',
    periodic_reaudit: 'periodic_reaudit',
};
export const LeaseOccupancyType = {
    Conventional: 'Conventional',
    Student: 'Student',
    Affordable: 'Affordable',
};
export const LeasePacketInputType = {
    LeasePacket: 'LeasePacket',
};
export const LoggedInStatus = {
    has_logged_in: 'has_logged_in',
    has_not_logged_in: 'has_not_logged_in',
};
export const MatchedLeaseStatus = {
    with_packet_and_application: 'with_packet_and_application',
    without_packet_or_application: 'without_packet_or_application',
    without_packet: 'without_packet',
    without_application: 'without_application',
    without_any_documents: 'without_any_documents',
};
export const TransitionStage = {
    Discovery: 'Discovery',
    Delivery: 'Delivery',
};
export const OrderType = {
    Subscription_Contract: 'Subscription Contract',
    Utilization_Order: 'Utilization Order',
    Utilization_Pricing_Agreement: 'Utilization Pricing Agreement',
    Utilization_Prepurchase_Amount: 'Utilization Prepurchase Amount',
};
export const ParkingAddendumInputType = {
    ParkingAddendum: 'ParkingAddendum',
};
export const PmsType = {
    yardi: 'yardi',
    entrata: 'entrata',
    realpage: 'realpage',
    sharepoint: 'sharepoint',
    valence_docs: 'valence_docs',
};
export const ScrapeRunStatus = {
    pending: 'pending',
    running: 'running',
    paused_awaiting_auth: 'paused_awaiting_auth',
    auth_expired: 'auth_expired',
    completed: 'completed',
    failed: 'failed',
};
export const ProfilingMode = {
    markdown: 'markdown',
    native: 'native',
};
export const ProofOfInsuranceInputType = {
    ProofOfInsurance: 'ProofOfInsurance',
};
export const PropertyHealthChartKey = {
    recoverableRevenueByFailure: 'recoverableRevenueByFailure',
    recoverableRevenueByPriority: 'recoverableRevenueByPriority',
    recoverableRevenueByCheck: 'recoverableRevenueByCheck',
    recoverableRevenueExpiringLeases: 'recoverableRevenueExpiringLeases',
    overchargingByPriority: 'overchargingByPriority',
    overchargingByCheck: 'overchargingByCheck',
    chargesNotFoundByPriority: 'chargesNotFoundByPriority',
    chargesNotFoundByCheck: 'chargesNotFoundByCheck',
    excessConcessions: 'excessConcessions',
    insufficientConcessions: 'insufficientConcessions',
    depositDiscrepancies: 'depositDiscrepancies',
};
export const PydanticFieldRenderKind = {
    string: 'string',
    number: 'number',
    boolean: 'boolean',
    date: 'date',
    amount: 'amount',
    list: 'list',
    object: 'object',
    unknown: 'unknown',
};
export const RenewalOfferInputType = {
    RenewalOffer: 'RenewalOffer',
};
export const RentConcessionAddendumInputType = {
    RentConcessionAddendum: 'RentConcessionAddendum',
};
export const ReportAdditionalGroupBy = {
    check_type: 'check_type',
    priority: 'priority',
};
export const ReportBreakdownDimension = {
    property: 'property',
    occupancy_type: 'occupancy_type',
};
export const ResolveFolderFilterAction = {
    include: 'include',
    exclude: 'exclude',
};
export const RoommateAmendmentInputType = {
    RoommateAmendment: 'RoommateAmendment',
};
export const ScreeningDecisionLetterInputType = {
    ScreeningDecisionLetter: 'ScreeningDecisionLetter',
};
export const SecurityDepositWaiverAddendumInputType = {
    SecurityDepositWaiverAddendum: 'SecurityDepositWaiverAddendum',
};
export const ShortTermLeaseAddendumInputType = {
    ShortTermLeaseAddendum: 'ShortTermLeaseAddendum',
};
export const SystemRoleType = {
    Admin: 'Admin',
    PropertyManager: 'PropertyManager',
    AssistantPropertyManager: 'AssistantPropertyManager',
    LeasingAgent: 'LeasingAgent',
    MaintenanceSupervisor: 'MaintenanceSupervisor',
    MaintenanceTech: 'MaintenanceTech',
    MaintenanceDirector: 'MaintenanceDirector',
    RegionalManager: 'RegionalManager',
    RegionalDirector: 'RegionalDirector',
    VicePresident: 'VicePresident',
    ComplianceManager: 'ComplianceManager',
    TransitionsUser: 'TransitionsUser',
    TransitionsGuestUser: 'TransitionsGuestUser',
    TransitionsAdmin: 'TransitionsAdmin',
    Other: 'Other',
};
export const TaskSortParam = {
    priority: 'priority',
    '-priority': '-priority',
    completed_date: 'completed_date',
    '-completed_date': '-completed_date',
    task_type: 'task_type',
    '-task_type': '-task_type',
    property_name: 'property_name',
    '-property_name': '-property_name',
    created_date: 'created_date',
    '-created_date': '-created_date',
    overall_failure_priority: 'overall_failure_priority',
    '-overall_failure_priority': '-overall_failure_priority',
};
export const TransitionDocRequestAgentSettingsPartialType = {
    TransitionDocRequestAgentSettings: 'TransitionDocRequestAgentSettings',
};
export const TransitionDocumentClassificationCategory = {
    Financials: 'Financials',
    Lending_and_Ownership: 'Lending and Ownership',
    Insurance: 'Insurance',
    Affordable_Housing: 'Affordable Housing',
    Leasing_and_Residents: 'Leasing and Residents',
    Property_Operations: 'Property Operations',
    Vendors_and_Contracts: 'Vendors and Contracts',
    Management_and_Organization: 'Management and Organization',
    Property_Information: 'Property Information',
};
export const TransitionFileUploadProcessingStatus = {
    pending: 'pending',
    processing: 'processing',
    paused_size_review: 'paused_size_review',
    paused_folder_review: 'paused_folder_review',
    completed: 'completed',
    failed: 'failed',
    skipped: 'skipped',
};
export const TransitionFileUploadUserStatus = {
    pending: 'pending',
    processing: 'processing',
    paused: 'paused',
    completed: 'completed',
    failed: 'failed',
    skipped: 'skipped',
};
export const TransitionHomeCardKey = {
    needs_review: 'needs_review',
    overdue: 'overdue',
    on_track: 'on_track',
};
export const TransitionSortParam = {
    created_at: 'created_at',
    '-created_at': '-created_at',
    updated_at: 'updated_at',
    '-updated_at': '-updated_at',
    name: 'name',
    '-name': '-name',
    target_completion_date: 'target_completion_date',
    '-target_completion_date': '-target_completion_date',
    completed_at: 'completed_at',
    '-completed_at': '-completed_at',
};
export const TransitionVariableSource = {
    manual: 'manual',
    template_default: 'template_default',
};
export const TrialAuditBatchStatus = {
    Pending: 'Pending',
    Running: 'Running',
    Completed: 'Completed',
    Failed: 'Failed',
};
export const TrialAuditCheckFlipDirection = {
    fail_to_pass: 'fail_to_pass',
    pass_to_fail: 'pass_to_fail',
    unchanged: 'unchanged',
};
export const TrialAuditCheckReviewState = {
    unreviewed: 'unreviewed',
    improved: 'improved',
    regressed: 'regressed',
};
export const UpdateAuditExplanationFeedback = {
    HELPFUL: 'HELPFUL',
    NOT_HELPFUL: 'NOT_HELPFUL',
};
export const UserRoleSource = {
    Entrata: 'Entrata',
    Surface: 'Surface',
    Yardi: 'Yardi',
    HappyCo: 'HappyCo',
};
export const UserEnabledStatus = {
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    Any: 'Any',
};
export const UserPermissionsPropertyMatchMode = {
    all: 'all',
    any: 'any',
};
export const UserSortBy = {
    first_name: 'first_name',
    '-first_name': '-first_name',
    last_name: 'last_name',
    '-last_name': '-last_name',
    email: 'email',
    '-email': '-email',
    last_login: 'last_login',
    '-last_login': '-last_login',
    last_seen_date: 'last_seen_date',
    '-last_seen_date': '-last_seen_date',
    created_date: 'created_date',
    '-created_date': '-created_date',
};
export const UtilityAddendumInputType = {
    UtilityAddendum: 'UtilityAddendum',
};
export const SurfaceCoreAuditingEnumsLeaseType = {
    Lease: 'Lease',
    Renewal: 'Renewal',
};
export const TasksApiWorkspaceTasksGetPriorityGroup = {
    high: 'high',
    medium: 'medium',
    low: 'low',
};
export const TasksExportApiWorkspaceTasksExportGetPriorityGroup = {
    high: 'high',
    medium: 'medium',
    low: 'low',
};
export const GetAuditConfigReportingApiSurfopsAuditingReportingAuditConfigGetPropertyType = {
    Conventional: 'Conventional',
    Student: 'Student',
};
export const GetAuditConfigReportingApiSurfopsAuditingReportingAuditConfigGetProductType = {
    Lease_Audit: 'Lease Audit',
    Due_Diligence: 'Due Diligence',
};
export const GetAuditConfigReportingApiSurfopsAuditingReportingAuditConfigGetMode = {
    property: 'property',
    checkset: 'checkset',
    check: 'check',
};
export const GetAuditConfigReportingApiSurfopsAuditingReportingAuditConfigGetFormat = {
    json: 'json',
    csv: 'csv',
};
